import { useEffect, useState } from 'react';
// import { LanguageService } from '@tx/language-service';
import { getCookie } from 'cookies-next';

import useCheckIsAuthenticatedUser from './useCheckIsAuthenticatedUser';

interface TranslationState {
  translations: Record<string, any>;
  isLoading: boolean;
  error: Error | null;
}

export const useTranslations = (section: string): TranslationState => {
  const { isAuthenticated, userInfo } = useCheckIsAuthenticatedUser();
  const cookieLanguage = getCookie('NEXT_LOCALE');

  // Initialize state based on language - no loading for en-US
  const [state, setState] = useState<TranslationState>({
    translations: {},
    isLoading: cookieLanguage !== 'en-US', // Only load for non-English
    error: null,
  });

  useEffect(() => {
    // Minimal behavior: do not load translations; use English fallbacks
    setState({
      translations: {},
      isLoading: false,
      error: null,
    });
  }, [section, isAuthenticated, cookieLanguage, userInfo]);

  return state;
};
